import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { alpha, withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import { FormControl } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";

export const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
    label: {
      color: "#000000",
    },
  },
  input: {
    borderRadius: 2,
    position: "relative",
    backgroundColor: "#fafafa",
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

export default function PaymentForm() {
  return (
    <React.Fragment>
      <Typography
        style={{ textTransform: "uppercase" }}
        variant="h4"
        align="center"
      >
        प्रशिक्षार्थि दर्ता गर्नुहोस्
      </Typography>
      <Typography variant="h6" gutterBottom>
        प्रशिक्षण विवरण
      </Typography>
      <Grid container spacing={3} style={{ marginBottom: "30px" }}>
        <Grid item xs={12} md={12}>
          <FormControl>
            <InputLabel
              shrink
              style={{ color: "#000" }}
              htmlFor="bootstrap-input"
            >
              Bootstrap
            </InputLabel>
            <BootstrapInput
              defaultValue="react-bootstrap"
              fullWidth
              id="bootstrap-input"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Typography variant="h6" gutterBottom>
        व्यक्तिगत विवरणहरू
      </Typography>
      <Grid container spacing={3} style={{ marginBottom: "30px" }}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="cardName"
            label="Name on card"
            fullWidth
            autoComplete="cc-name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="cardNumber"
            label="Card number"
            fullWidth
            autoComplete="cc-number"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="expDate"
            label="Expiry date"
            fullWidth
            autoComplete="cc-exp"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="cvv"
            label="CVV"
            helperText="Last three digits on signature strip"
            fullWidth
            autoComplete="cc-csc"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="expDate"
            label="Expiry date"
            fullWidth
            autoComplete="cc-exp"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="cvv"
            label="CVV"
            helperText="Last three digits on signature strip"
            fullWidth
            autoComplete="cc-csc"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
